import React from "react";
import { OogwaiLogo2, OogwaiTextLogo } from "../Icons/iconImages";
import IconRings from "../IconRings";

/**
 * Brand lockup: monk icon (wrapped in concentric IconRings) + product name
 * wordmark + "by oogw.ai" subtitle. The product name is configurable via `name`.
 * Reuses Oogwai-logo-2.svg (icon) and Oogwai-logo-text.svg (the "oogw.ai" wordmark).
 */
const BrandLogo = ({
  name = "Compass",
  className = "",
  iconClassName = "h-10 w-10",
  ringClassName = "p-2",
  nameClassName = "text-2xl",
  numRings = 3,
  ringBaseSize = 60,
  ringSpacing = 18,
  showBeta = false,
}) => {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="relative flex shrink-0 items-center justify-center">
        <IconRings
          numRings={numRings}
          ringBaseSize={ringBaseSize}
          ringSpacing={ringSpacing}
          ringColor="#E7ECEA"
          innerClassName="w-fit h-fit"
          className="top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-10"
        >
          <div
            className={`flex items-center justify-center rounded-full bg-white ${ringClassName}`}
          >
            <OogwaiLogo2 className={iconClassName} />
          </div>
        </IconRings>
      </div>

      <div className="flex flex-col justify-center leading-none">
        <span
          className={`font-sans font-medium tracking-tight text-[#1A6643] leading-none ${nameClassName}`}
        >
          {name}
        </span>

        <div className="mt-0.5 ml-0.5 flex items-baseline gap-1">
          <span className="font-sans text-[0.725rem] font-medium text-[#717680] leading-none">by</span>
          <OogwaiTextLogo
            preserveAspectRatio="xMinYMid meet"
            className="h-[0.72rem] w-[2.42rem] shrink-0 overflow-visible translate-y-[3px]"
          />

          {showBeta && (
            <span className="self-center ml-0.5 rounded-full border border-[#4C8067]/40 bg-[#F5FAF7] px-1.5 py-[1px] text-[0.62rem] font-semibold leading-none text-[#4C8067]">
              Beta
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrandLogo;
